import { useState } from "react";
import { supabase } from "./supabaseclient";

const T = {
  bg: "#06090f",
  card: "#0f1623",
  border: "#1a2540",
  gold: "#c9a96e",
  goldLight: "#e8c98a",
  text: "#e8eaf0",
  textMid: "#7a8599",
  textDim: "#3d4a5c",
};

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function handleResetPassword() {
    setError("");
    setMessage("");

    if (!password || !confirmPassword) {
      setError("Please fill in both password fields.");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    const { error } = await supabase.auth.updateUser({
      password,
    });

    if (error) {
      setError(error.message);
    } else {
      setMessage("Password updated successfully. You can now sign in.");
    }

    setLoading(false);
  }

  return (
    <div
      style={{
        background: T.bg,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      <div
        style={{
          background: T.card,
          border: `1px solid ${T.border}`,
          borderRadius: 16,
          padding: 40,
          width: "100%",
          maxWidth: 420,
          boxShadow: "0 30px 80px rgba(0,0,0,0.5)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div
            style={{
              fontSize: 32,
              color: T.gold,
              marginBottom: 10,
            }}
          >
            🔐
          </div>
          <div
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: T.goldLight,
              marginBottom: 6,
              fontFamily: "'Cormorant Garamond', serif",
            }}
          >
            Reset Password
          </div>
          <div style={{ fontSize: 13, color: T.textDim }}>
            Enter your new password below.
          </div>
        </div>

        {error && (
          <div
            style={{
              background: "rgba(248,113,113,0.08)",
              border: "1px solid rgba(248,113,113,0.25)",
              borderRadius: 8,
              padding: "10px 14px",
              fontSize: 13,
              color: "#f87171",
              marginBottom: 16,
            }}
          >
            {error}
          </div>
        )}

        {message && (
          <div
            style={{
              background: "rgba(34,197,94,0.08)",
              border: "1px solid rgba(34,197,94,0.25)",
              borderRadius: 8,
              padding: "10px 14px",
              fontSize: 13,
              color: "#86efac",
              marginBottom: 16,
            }}
          >
            {message}
          </div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label
            style={{
              display: "block",
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.7px",
              textTransform: "uppercase",
              color: T.textDim,
              marginBottom: 5,
            }}
          >
            New Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter new password"
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: 8,
              border: `1px solid ${T.border}`,
              background: "#0b0f1a",
              color: T.text,
            }}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label
            style={{
              display: "block",
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.7px",
              textTransform: "uppercase",
              color: T.textDim,
              marginBottom: 5,
            }}
          >
            Confirm Password
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
            style={{
              width: "100%",
              padding: "10px 14px",
              borderRadius: 8,
              border: `1px solid ${T.border}`,
              background: "#0b0f1a",
              color: T.text,
            }}
          />
        </div>

        <button
          onClick={handleResetPassword}
          disabled={loading}
          style={{
            width: "100%",
            background: `linear-gradient(135deg,${T.gold},${T.goldLight})`,
            color: "#07090e",
            border: "none",
            borderRadius: 8,
            padding: "13px",
            fontSize: 14,
            fontWeight: 700,
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? "Updating..." : "Update Password"}
        </button>
      </div>
    </div>
  );
}